// extracted by mini-css-extract-plugin
export default {"container":"kxU9H8U1","pencil":"YT_p14CS"};